export default {
  Inputfield: "Please enter",
  Dropdownfield: "Please select",
  Searchfield: "Search <object name>",
  searchTable: "Search Table",
  createTag: "Create a tag...",
  selectALocation: "Select a location...",
};
